import { AccordionCivilUnion as CivilUnionVM } from 'shell/view-models/accordion-civil-union';
import { CivilUnion } from 'shell/models/person/civil-union';
import { transformCitizen } from '../citizenship-shared';
import { transformEventData } from '../event-datas-shared';
import { transformGenerality } from '../registry-office/generality';

export const transformCivilUnion = (values: CivilUnionVM | undefined): CivilUnion | undefined => {
  const {
    isForeign,
    eventDate,
    eventChoiceDate,
    exceptionalLocation,
    municipality,
    year,
    province,
    documentNumber,
    portion,
    range,
    regVol,
    office,
    documentDate,
    transcript,
  } = values || {};

  const unitoCivilmente = transformGenerality(values?.generality || null, values?.person || null);

  const cittadinanza = transformCitizen({
    citizenship: values?.citizenship?.value || '',
    code: values?.citizenship?.id || values?.citizenshipCode || '',
    note: values?.note,
    validityDate: values?.from?.toFormat('dd/MM/yyyy') || '',
  });

  const attoUnione = transformEventData({
    isForeign,
    eventDate,
    eventChoiceDate,
    exceptionalLocation,
    municipality,
    year,
    province,
    documentNumber,
    portion,
    range,
    regVol,
    office,
    documentDate,
    transcript,
    location: {
      exceptionalLocation: values?.exceptionalLocation || '',
      localita:
        (!values?.isForeign
          ? values?.italian?.location
          : values?.foreign?.municipality?.description) || '',
      foreignState: values?.foreign?.state,
      municipality: values?.italian?.municipality,
    },
    digital: values?.isDigital ? values.digital || undefined : undefined,
  });

  const returnData: CivilUnion | undefined = values
    ? {
        unitoCivilmente,
        cittadinanza,
        attoUnione,
        ordineUnione: values?.number?.toString() || undefined,
      }
    : undefined;

  return returnData;
};
